// Centralized app destination URLs. Each is env-driven with a fallback default,

export const ASSESSMENT_URL = process.env.REACT_APP_ASSESSMENT_URL || 'https://assessments.simsola.dev';
export const CANDIDATE_URL = process.env.REACT_APP_CANDIDATE_URL || 'https://candidate.simsola.dev';
export const MYCOACH_URL = process.env.REACT_APP_MYCOACH_URL || 'https://www.simsola.dev/';

export const FREE_TRIAL_URL = process.env.REACT_APP_FREE_TRIAL_URL || `${ASSESSMENT_URL}/auth/redirecting?action=signup`;

// On-site product pages that sit between the product entry points and the apps.
export const ASSESSMENT_BUSINESS_PATH = '/assessment-service';
export const ASSESSMENT_CANDIDATE_PATH = '/assessment-service/candidates';
